import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService, AuthServiceConfig } from './auth.service';
/**
 * @param {?} config
 * @return {?}
 */
export function configFactory(config: AuthServiceConfig) {
  return config;
}
export class SocialLoginModule {
/**
 * @param {?} config
 * @return {?}
 */
public static initialize(config: AuthServiceConfig): ModuleWithProviders {
    return {
      ngModule: SocialLoginModule,
      providers: [
        AuthService,
        {
          provide: AuthServiceConfig,
          useValue: config
        }
      ]
    };
  }

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  providers: [
    AuthService
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SocialLoginModule_tsickle_Closure_declarations() {
/** @type {?} */
SocialLoginModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SocialLoginModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
